"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type FC, type PropsWithChildren, use, useState } from "react";
import { useStore } from "zustand";
import { createGistsStore, type GistsState, type GistsStore } from "~/client/services";
interface GistsStoreProviderProps {
  readonly initialState?: GistsState;
}
type GistsStoreApi = ReturnType<typeof createGistsStore>;
export const GistsStoreContext = createContext<GistsStoreApi | undefined>(undefined);
export const GistsStoreProvider: FC<PropsWithChildren<GistsStoreProviderProps>> = t0 => {
  const $ = _c(7);
  const {
    children,
    initialState: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      data: [],
      isPending: false
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const initialState = t2;
  let t3;
  if ($[2] !== initialState) {
    t3 = () => createGistsStore(initialState);
    $[2] = initialState;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [store] = useState(t3);
  let t4;
  if ($[4] !== children || $[5] !== store) {
    t4 = <GistsStoreContext value={store}>{children}</GistsStoreContext>;
    $[4] = children;
    $[5] = store;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useGistsStore = selector => {
  const store = use(GistsStoreContext);
  if (!store) {
    throw new Error("useGistsStore must be used within a GistsStoreProvider");
  }
  return useStore(store, selector);
};